export default {
    state: {
        notifications: ''
    },
    mutations: {
        setNotifications(state, payload) {
            state.notifications = payload
        }
    },
    actions: {
        async getNofitications({dispatch, commit}) {
            dispatch('sendRequest', {method: 'GET', endpoint: '/notifications/all'})
            .then(response => response.json())
            .then(data => {
                commit('setNotifications', data)
            })
        },
        async passedNotifications({dispatch}) {
            dispatch('sendRequest', {method: 'GET', endpoint: '/notifications/passed'})
            .then(response => response.json())
            .then(() => {
                dispatch('getNofitications')
            })
        }
    },
    getters: {
        notifications(state) {
            return state.notifications
        }
    }
}